/// <reference path="../../../../../rest.d.ts"/>
/// <reference path="../../../../../typings/index.d.ts"/>

class StorageQuantityInputComponentCtrl implements ng.IController {
    public storageQuantity: StorageQuantityDto;
    public availableQuantityForDisabledForm: string;
    public id: number;
    public label: string;
    public placeholder: string;

    constructor(private $filter: ng.IFilterService) {}

    $onInit(): void {
        this.id = Math.ceil(Math.random() * 1000);
        this.changeDisabledValue();
    }

    changeDisabledValue(): void {
        this.availableQuantityForDisabledForm = this.$filter('number')(
            this.storageQuantity.value
        );
    }
}

angular.module('app').component('pkpStorageQuantityInput', {
    controller: StorageQuantityInputComponentCtrl,
    template: require('app/storage-offer/storage-quantity-input.component.html'),
    bindings: {
        storageQuantity: '=',
        disabled: '<',
        label: '<',
        placeholder: '<',
        form: '='
    }
});
